import { curry } from 'lodash';

export const mapPlansDataToMap = (plans) =>
  plans.reduce((acc, plan, key) => ({
    ...acc,
    [plan.type]: key,
  }), {}
);

export const mapPlans = curry((plans: any, currentPlanType) => 
  plans.map((plan) => ({
    ...plan,
    isTrial: plan.type === 'medium' || plan.type === 'large',
    isCurrent: plan.type === currentPlanType
  })
));
